import { gql } from '@apollo/client'

export const updateUserNameMutation = gql`
  mutation ($name: String!) {
    updateUser(name: $name) {
      name
    }
  }
`

export const updateUserEmailMutation = gql`
  mutation ($email: String!) {
    updateUser(email: $email) {
      email
    }
  }
`

export const delete2faSettingsMutation = gql`
  mutation ($id: ID!, $password: String!) {
    delete2faSettings(id: $id, password: $password) {
      statusCode
      error
    }
  }
`
export const deleteUserMutation = gql`
  mutation ($id: ID) {
    deleteUser(id: $id) {
      statusCode
      error
    }
  }
`

export const requestInstallReminderEmailMutation = gql`
  mutation ($id: ID) {
    requestInstallReminderEmail(id: $id) {
      statusCode
      error
    }
  }
`

export const userQuery = gql`
  query ($id: ID!) {
    user(id: $id) {
      email
      hasActivePlan
      id
      name
      planExpiresOn
      planType
      trialExpiresOn
    }
  }
`

export const updateNotificationSettingsMutation = gql`
  mutation ($userId: ID!, $notificationSettings: [JSONString]!) {
    updateNotificationSettings(
      userId: $userId
      notificationSettings: $notificationSettings
    ) {
      updatedSettings
    }
  }
`

export const addCredentialEmailPassword = gql`
  mutation ($email: String!, $password: String!) {
    addCredentialEmailPassword(email: $email, password: $password) {
      email
    }
  }
`

export const startTrialMutation = gql`
  mutation StartTrial($userId: ID!, $platform: String!) {
    startTrial(userId: $userId, platform: $platform) {
      success
    }
  }
`

export const redeemEnterpriseBasicSignonStripeCodeMutation = gql`
  mutation ($code: String!) {
    redeemEnterpriseBasicSignonStripeCode(code: $code) {
      success
    }
  }
`

export const redeemEnterpriseLicenseCodeMutation = gql`
  mutation redeemEnterpriseLicenseCode($code: String!) {
    redeemEnterpriseLicenseCode(code: $code) {
      success
      error
    }
  }
`
